import { render, staticRenderFns } from "./ripConsulta.vue?vue&type=template&id=59ece42d"
import script from "./ripConsulta.vue?vue&type=script&lang=js"
export * from "./ripConsulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports